import script from "./ChatItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatItem.vue?vue&type=script&setup=true&lang=ts"

import "./ChatItem.vue?vue&type=style&index=0&id=1984e565&scoped=true&lang=scss"

import exportComponent from "E:\\work\\EEEEE\\okpay\\ipay-imi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1984e565"]])

export default __exports__